import { useEffect, useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import './PdfViewer.css';

// ---------------------------------------------------------------------------
// POR QUE ESTE COMPONENTE EXISTE
// O conteúdo de PDF (ex.: "História em Quadrinhos") era renderizado num
// `<iframe src="....pdf">`. Isso funciona no navegador do desktop, que tem
// visualizador de PDF embutido — mas o **WebView do Android NÃO tem**, e o app
// da Play Store (que é uma casca em volta deste site) mostrava a tela em branco.
// Aqui o PDF é desenhado em canvas pelo PDF.js, então funciona em qualquer lugar.
//
// WORKER: precisa ser servido da PRÓPRIA origem. O CSP do app (index.html) só
// permite `worker-src 'self' blob:` — um worker de CDN seria bloqueado. O arquivo
// é copiado de node_modules pelo script `copy:pdf-worker` (roda no pre-start e
// pre-build). Usamos a extensão **.js** e não .mjs de propósito: o pdf.js cria o
// worker com `{ type: 'module' }`, e o navegador RECUSA um módulo que não venha
// com MIME de JavaScript — o Apache da Hostinger não conhece o MIME de `.mjs`.
// ---------------------------------------------------------------------------
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';

export default function PdfViewer({ url, title }) {
    const wrapRef = useRef(null);
    const [width, setWidth] = useState(0);
    const [numPages, setNumPages] = useState(0);
    const [failed, setFailed] = useState(false);

    // Largura real do container → as páginas acompanham a tela (celular incluso).
    useEffect(() => {
        const el = wrapRef.current;
        if (!el) return undefined;
        setWidth(el.clientWidth);
        const ro = new ResizeObserver(([entry]) => setWidth(entry.contentRect.width));
        ro.observe(el);
        return () => ro.disconnect();
    }, []);

    // Troca de conteúdo → recomeça limpo.
    useEffect(() => {
        setNumPages(0);
        setFailed(false);
    }, [url]);

    // Último recurso: se o PDF.js não conseguir abrir, o usuário ainda baixa o arquivo.
    const fallback = (
        <div className="pdf-viewer__msg">
            <p>Não foi possível exibir este conteúdo aqui.</p>
            <a className="pdf-viewer__download" href={url} target="_blank" rel="noreferrer">
                Baixar o PDF
            </a>
        </div>
    );

    return (
        <div className="pdf-viewer" ref={wrapRef}>
            {failed ? fallback : (
                <Document
                    file={url}
                    onLoadSuccess={({ numPages: n }) => setNumPages(n)}
                    onLoadError={() => setFailed(true)}
                    onSourceError={() => setFailed(true)}
                    loading={<div className="pdf-viewer__msg"><p>Carregando…</p></div>}
                    error={fallback}
                    noData={fallback}
                >
                    {/* Quadrinho é curto: mostra todas as páginas em rolagem (sem paginação). */}
                    {Array.from({ length: numPages }, (_, i) => (
                        <Page
                            key={`${url}-${i}`}
                            pageNumber={i + 1}
                            width={width || undefined}
                            className="pdf-viewer__page"
                            // Quadrinhos são imagens: sem camada de texto/anotação o
                            // render fica mais leve (importa no Android fraco).
                            renderTextLayer={false}
                            renderAnnotationLayer={false}
                            loading=""
                        />
                    ))}
                </Document>
            )}

            {!failed && numPages > 0 && (
                <p className="pdf-viewer__count">
                    {title ? `${title} — ` : ''}{numPages} {numPages === 1 ? 'página' : 'páginas'}
                </p>
            )}
        </div>
    );
}
